import { render, staticRenderFns } from "./BalanceCell.vue?vue&type=template&id=31000b24&"
import script from "./BalanceCell.vue?vue&type=script&lang=js&"
export * from "./BalanceCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports